import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LeadHistoryAuditItemBase } from '../audit-item.base';
import { AuditItemAssignmentInput } from './audit-item-assignment-input.model';

@Component({
    selector: 'app-audit-item-assignment',
    templateUrl: './audit-item-assignment.component.html',
    styleUrls: ['./audit-item-assignment.component.scss'],
    standalone: false
})
export class AuditItemAssignmentComponent extends LeadHistoryAuditItemBase implements OnInit {

  assignment: AuditItemAssignmentInput | undefined = undefined

  @Input() set input(input: AuditItemAssignmentInput) {
    this.assignment = input
  }

  constructor() { super() }

  ngOnInit(): void {
  }

}
